import { useFlag } from '@unleash/proxy-client-react';

/**
 * Return a boolean based on whether a given feature flag is enabled.
 * Retrieves feature flags from Unleash using unleash sdk hook.
 * @param {string} feature The key of the feature flag
 * @returns {boolean} Status of the feature flag
 * @example
 * const isDeviceInventoryEnabled = useFeatureFlag('DEVICE_INVENTORY');
 */
export const useFeatureFlag = (feature: string): boolean => useFlag(feature);
